// extracted by mini-css-extract-plugin
export default {"page_title":"profile_page_title__8ep8s","changePassword":"profile_changePassword__u5xG0"};